import initCells from './initCells';

export default initCells;
